import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    ...theme.layouts.stepGrid,
    heading: {
      marginTop: '4rem',
      marginBottom: '3rem',
      maxWidth: '35rem',
    },
    timeoutClock: {
      height: '30rem',
      width: '50vw',
      fill: 'none',
      verticalAlign: 'middle',
    },
    gridContainer: {
      position: 'relative',
    },
    gridMain: {
      '@media (max-width: 767px)': {
        marginBottom: '2rem',
      },
    },
    gridImageContent: {
      textAlign: 'center',
      marginTop: '2rem',
      '@media (max-width: 599px)': {
        display: 'none',
      },
    },
    lineHeight: {
      lineHeight: '2rem',
    },
  }),
  { index: 1 },
);